/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { Role } from './Role';
import {
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
    RoleToJSONTyped,
} from './Role';
import type { Permission } from './Permission';
import {
    PermissionFromJSON,
    PermissionFromJSONTyped,
    PermissionToJSON,
    PermissionToJSONTyped,
} from './Permission';

/**
 * 
 * @export
 * @interface UserPermissionsResponse
 */
export interface UserPermissionsResponse {
    /**
     * 
     * @type {Array<Role>}
     * @memberof UserPermissionsResponse
     */
    roles: Array<Role> | null;
    /**
     * 
     * @type {Array<Permission>}
     * @memberof UserPermissionsResponse
     */
    permissions: Array<Permission> | null;
    /**
     * 
     * @type {number}
     * @memberof UserPermissionsResponse
     */
    permissionCount?: number;
}

/**
 * Check if a given object implements the UserPermissionsResponse interface.
 */
export function instanceOfUserPermissionsResponse(value: object): value is UserPermissionsResponse {
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function UserPermissionsResponseFromJSON(json: any): UserPermissionsResponse {
    return UserPermissionsResponseFromJSONTyped(json, false);
}

export function UserPermissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roles': (json['roles'] == null ? null : (json['roles'] as Array<any>).map(RoleFromJSON)),
        'permissions': (json['permissions'] == null ? null : (json['permissions'] as Array<any>).map(PermissionFromJSON)),
        'permissionCount': json['permissionCount'] == null ? undefined : json['permissionCount'],
    };
}

export function UserPermissionsResponseToJSON(json: any): UserPermissionsResponse {
    return UserPermissionsResponseToJSONTyped(json, false);
}

export function UserPermissionsResponseToJSONTyped(value?: UserPermissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roles': (value['roles'] == null ? null : (value['roles'] as Array<any>).map(RoleToJSON)),
        'permissions': (value['permissions'] == null ? null : (value['permissions'] as Array<any>).map(PermissionToJSON)),
        'permissionCount': value['permissionCount'],
    };
}

